import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import OTPInput from 'react-otp-input';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import validator from 'validator';
import { Post } from '../../Axios/AxiosFunctions';
import Button from '../../Component/Button/Button';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import { apiHeader, BaseURL } from '../../config/apiUrl';
import classes from './VerifyOtp.module.css';
import { useDispatch } from 'react-redux';
import { saveLoginUserData } from '../../store/auth/authSlice';
import {
  setAllCompareList,
  setAllFavorite,
  setAllInquiryMessageAndRequest,
  setAllPropertyProjectsAndEvents,
  setAllSavedSearch
} from '../../store/notification/notificationSlice';

function VerifyOtp() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const requiresOtp = searchParams.get('requiresOtp');
  const dispatch = useDispatch();

  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resend, setResend] = useState(true);

  useEffect(() => {
    if (!validator.isEmail(email)) {
      navigate('/login');
    }
  }, [email, navigate]);

  const onResend = async () => {
    if (resendLoading || !validator.isEmail(email)) {
      toast.warn('Email address is invalid');
      return;
    }

    setResendLoading(true);

    try {
      const response = await Post(
        BaseURL(`users/resend-otp`),
        { email, fromForgotPassword: true },
        apiHeader()
      );

      if (response) {
        setResend(true);
        toast.success('Verification code has been sent to your email.');
      }
    } catch (error) {
      toast.error('Failed to resend verification code.'||error?.message);
    } finally {
      setResendLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (otp.length < 6) {
      toast.warn('Please enter a 6-digit OTP.');
      return;
    }

    setLoading(true);

    try {
      const url = requiresOtp ? 'users/agent/company/verify-otp' : 'users/verify-user-otp';
      const body = requiresOtp
        ? { email, otpCode: otp, fromForgotPassword: false }
        : { email, otpCode: otp, fromForgotPassword: true };
      const response = await Post(BaseURL(url), body, apiHeader());

      if (response) {
        toast.success('Successfully Verified OTP');
        if (requiresOtp) {
          dispatch(saveLoginUserData(response?.data));
          if (response?.data?.data?.propertyProjectsAndEvents) {
            dispatch(
              setAllPropertyProjectsAndEvents(response?.data?.data?.propertyProjectsAndEvents)
            );
          }
          if (response?.data?.data?.favorite) {
            dispatch(setAllFavorite(response?.data?.data?.favorite));
          }
          if (response?.data?.data?.savedSearches) {
            dispatch(setAllSavedSearch(response?.data?.data?.savedSearches));
          }
          if (response?.data?.data?.compareList) {
            dispatch(setAllCompareList(response?.data?.data?.compareList));
          }
          if (response?.data?.data?.inquiryMessageAndRequest) {
            dispatch(
              setAllInquiryMessageAndRequest(response?.data?.data?.inquiryMessageAndRequest)
            );
          }
          if (response?.data?.data?.user?.role == 'company') {
            navigate('/company/dashboard');
          }
          setLoading(false);
          return;
        }
        navigate(`/reset-password?email=${email}&code=${otp}`);
      } else {
        setOtp('');
      }
    } catch (error) {
      console.error('Error verifying OTP:'|| error);
      toast.error('Failed to verify OTP.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container>
        <div className={classes.mainContainer}>
          <div className={classes._main}>
            <h1>OTP Verification</h1>
            <p>
              Please enter the one-time password (OTP) sent to {email || 'your registered email'}.
            </p>
            <div className={classes._form}>
              <div className="d-flex align-items-center flex-column gap-3">
                <div className={classes._inputContainer}>
                  <OTPInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderInput={(props) => <input {...props} />}
                    shouldAutoFocus
                  />
                </div>
                <CountdownCircleTimer
                  key={resend ? 1 : 0}
                  isPlaying={resend}
                  duration={120}
                  size={150}
                  strokeWidth={6}
                  colors={'#00a997'}
                  onComplete={() => setResend(false)}>
                  {({ remainingTime }) => {
                    const minutes = Math.floor(remainingTime / 60);
                    const seconds = remainingTime % 60;

                    return (

                      <span
                        style={{ fontSize: '20px' }}
                       
                        className={!resend && classes.resendText}>

                          <button className='btnWrapper'
                           onClick={onResend}
                          >
                        {resend
                          ? `0${minutes} : ${seconds < 10 ? '0' + seconds : seconds}`
                          : resendLoading
                          ? 'Resending...'
                          : 'Resend'}
                          </button>
                      </span>
                    );
                  }}
                </CountdownCircleTimer>
              </div>

              <div className={classes._bottomDiv}>
                <Button
                  disabled={loading}
                  loading={loading}
                  label={loading ? 'Verifying...' : 'Verify'}
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}

export default VerifyOtp;
